module.exports = __webpack_public_path__ + "static/media/cl.ad886e45.svg";